import $ from "jquery";

import * as prefixes from '../resources/prefixes.json';
import titleProperties from '../resources/titleProperties.json';
import descriptionProperties from '../resources/descriptionProperties.json';
import types from '../resources/types.json';
import React from "react";
import {v4 as uuidv4} from "uuid";

// const queryDefault = "select distinct ?s ?p ?o { \n" +
// 	// eslint-disable-next-line no-template-curly-in-string
// 	"\t\t{<${IRI}> ?p ?o} \n" +
// 	"\t\tUNION \n" +
// 	// eslint-disable-next-line no-template-curly-in-string
// 	"\t\t{<${IRI}> ?p1 ?s . FILTER(isBlank(?s)) . ?s ?p ?o} \n" +
// 	"\t\tUNION \n" +
// 	// eslint-disable-next-line no-template-curly-in-string
// 	"\t\t{<${IRI}> ?p1 ?s1 .  FILTER(isBlank(?s1)) . ?s1 ?p2 ?s . FILTER(isBlank(?s)) . ?s ?p ?o}\n" +
// 	"\t\tUNION \n" +
// 	// eslint-disable-next-line no-template-curly-in-string
// 	"\t\t{<${IRI}> ?p1 ?s1 .  FILTER(isBlank(?s1)) . ?s1 ?p2 ?s2 . FILTER(isBlank(?s2)) . ?s2 ?p3 ?s . FILTER(isBlank(?s)) . ?s ?p ?o}\t\t\n" +
// 	"\t\t}"


// eslint-disable-next-line no-template-curly-in-string
const queryDirects = "select (count(distinct ?o) AS ?o) ?p {<${IRI}> ?p ?o. FILTER(!isBlank(?s))} GROUP BY ?p "

// eslint-disable-next-line no-template-curly-in-string
const resourceTitlePropertiesQuery = " PREFIX rdfs: <http://www.w3.org/2000/01/rdf-schema#>\n" +
	"PREFIX dcterms: <http://purl.org/dc/terms/>\n" +
	"PREFIX powla: <http://purl.org/powla/powla.owl#>\n" +
	// eslint-disable-next-line no-template-curly-in-string
	"select distinct ?o  { <${IRI}> ?filterProperty ?o. FILTER ( <${FILTERS}> )} "

const resourceDescriptionPropertiesQuery = " PREFIX rdfs: <http://www.w3.org/2000/01/rdf-schema#>\n" +
	"PREFIX dcterms: <http://purl.org/dc/terms/>\n" +
	"PREFIX rdfs: <http://www.w3.org/2000/01/rdf-schema#>\n" +
	"PREFIX dc: <http://purl.org/dc/elements/1.1/>\n" +
	"PREFIX skos: <http://www.w3.org/2004/02/skos/core#>\n" +
	// eslint-disable-next-line no-template-curly-in-string
	"select distinct ?filterProperty ?o  { <${IRI}> ?filterProperty ?o. FILTER ( <${FILTERS}> )} "

// eslint-disable-next-line no-template-curly-in-string
const inversePropertyQuery = "select (count(distinct ?s) AS ?o) ?p {?s ?p <${IRI}>. FILTER(!isBlank(?s))} GROUP BY ?p "


function executeSparql(query, callback) {
	// console.log(query);
	$.ajax({
		//  url: 'https://lila-erc.eu/sparql/lemmaBank/query?format=csv&query=' + encodeURIComponent(query),
		// eslint-disable-next-line no-template-curly-in-string
		url: 'https://lila-erc.eu/sparql/lila_knowledge_base/query?format=json&query=' + encodeURIComponent(queryDirects.replaceAll("${IRI}", query)),
		async: true,
		dataType: "json",

		success: function (data) {
			callback(data)
		}

	});
}


function inverseQuery(query, callback) {
	$.ajax({
		//  url: 'https://lila-erc.eu/sparql/lemmaBank/query?format=csv&query=' + encodeURIComponent(query),
		// eslint-disable-next-line no-template-curly-in-string
		url: 'https://lila-erc.eu/sparql/lila_knowledge_base/query?format=json&query=' + encodeURIComponent(inversePropertyQuery.replaceAll("${IRI}", query)),
		async: true,
		dataType: "json",

		success: function (data) {
			callback(data)
		}

	});
}


function renderWithNamespace(uri) {
	let formattedUri = <span>{"<" + uri + ">"}</span>;
	Object.entries(prefixes).forEach(([key, value]) => {
		if (uri.startsWith(key)) {
			// console.log(uri.replaceAll(key,value))
			formattedUri = <>{value}<span>{uri.replaceAll(key, "")}</span></>

		}
	})
	return formattedUri;
}


function buildFilterString(array) {
	let filters = []
	array.forEach(property => {
		filters.push("(?filterProperty =" + property + ")");
	})

	return filters.join(" || ");
}


function renderResourceDescription(uri) {
	return new Promise(function (resolve, reject) {
		// eslint-disable-next-line no-template-curly-in-string
		let queryDecr = resourceDescriptionPropertiesQuery.replaceAll("${IRI}", uri).replaceAll("<${FILTERS}>", buildFilterString(descriptionProperties))
		// console.log(queryDecr);
		$.ajax({
			//  url: 'https://lila-erc.eu/sparql/lemmaBank/query?format=csv&query=' + encodeURIComponent(query),
			// eslint-disable-next-line no-template-curly-in-string
			url: 'https://lila-erc.eu/sparql/lila_knowledge_base/query?format=json&query=' + encodeURIComponent(queryDecr),
			async: true,
			dataType: "json",

			success: function (data) {
				// console.log(data);
				let output = [];
				if (data.results.bindings.length > 0) {
					output.push(
						// <label className="">
						// <a data-label="" data-comment="" href={uri}>
						// 	{/*void:<span>vocabulary</span>*/}
						// 	{renderWithNamespace(data.results.bindings[0].filterProperty.value)}
						// </a></label>

						<label className="c1">
							<span className="iph"></span>
							<a data-label="Description" data-comment="An account of the resource."
							   href={data.results.bindings[0].filterProperty.value}>
								{renderWithNamespace(data.results.bindings[0].filterProperty.value)}
							</a>
						</label>)

					output.push(
						<div className="c2 value" style={{
							marginLeft: "147px", marginTop: "0px", paddingRight: "70px", visibility: "visible"
						}}>

							<div className="" data-lang="">
								{data.results.bindings[0].o.value}
								{/*<span className="dType"> xsd:string</span>*/}

							</div>

						</div>
					)

				}
				resolve(output);
			}
		})
	})


}


function renderResourceTitle(uri) {
	return new Promise(function (resolve, reject) {
		$.ajax({
			//  url: 'https://lila-erc.eu/sparql/lemmaBank/query?format=csv&query=' + encodeURIComponent(query),
			// eslint-disable-next-line no-template-curly-in-string
			url: 'https://lila-erc.eu/sparql/lila_knowledge_base/query?format=json&query=' + encodeURIComponent(resourceTitlePropertiesQuery.replaceAll("${IRI}", uri).replaceAll("<${FILTERS}>", buildFilterString(titleProperties))),
			async: true,
			dataType: "json",

			success: function (data) {
				if (data.results.bindings.length > 0) {
					// console.log(data.results.bindings[0]);
					resolve(<div key={uuidv4()}>
							<a title={uri}
							   href={uri}
							   className="isLocal">&lt;{uri}&gt;
								<br/>
								<span className="derivedTitle" style={{marginLeft: "15px"}}><tt
									className="sp"></tt>{data.results.bindings[0].o.value}
						</span>
							</a>
						</div>
					)
				} else {

					resolve(<div>
						<a title={"&lt;" + uri + "&gt;"} className=" "
						   href={uri} target="_blank" rel="noreferrer">
							&lt;{uri}&gt;
						</a>
					</div>)
				}


			},
			error: function (err) {
				reject(err) // Reject the promise and go to catch()
			}

		});
	})
}


function renderTokenContext(tokenIRI) {
	// console.log("renderTokenContext");

	let queryHeader = "PREFIX powla: <http://purl.org/powla/powla.owl#>\n"
		+ "SELECT * WHERE {\n" +
		"  VALUES ?token {<" + tokenIRI + ">}\n" +
		"?token powla:hasStringValue ?tokenLabel.\n" +
		"  optional{" +
		"?token powla:previous ?prev_t0.\n" +
		"?prev_t0 powla:hasStringValue ?prev_t0_label.\n";

	for (let i = 1; i < 10; i++) {
		queryHeader +=
			"  optional{" +
			"?prev_t" + (i - 1) + " powla:previous ?prev_t" + i + ".\n" +
			"?prev_t" + i + " powla:hasStringValue ?prev_t" + i + "_label.\n";
	}
	for (let i = 1; i < 10; i++) {
		queryHeader += "}";
	}
	queryHeader += "}";


	queryHeader += "  optional{" +
		"?token powla:next ?next_t0.\n" +
		"?next_t0 powla:hasStringValue ?next_t0_label.\n";

	for (let i = 1; i < 10; i++) {
		queryHeader +=
			"  optional{" +
			"?next_t" + (i - 1) + " powla:next ?next_t" + i + ".\n" +
			"?next_t" + i + " powla:hasStringValue ?next_t" + i + "_label.\n";
	}
	for (let i = 1; i < 10; i++) {
		queryHeader += "}";
	}
	queryHeader += "}";
	queryHeader += "}";

	return new Promise(function (resolve, reject) {
		$.ajax({
			//  url: 'https://lila-erc.eu/sparql/lemmaBank/query?format=csv&query=' + encodeURIComponent(query),
			// eslint-disable-next-line no-template-curly-in-string
			url: 'https://lila-erc.eu/sparql/lila_knowledge_base/query?format=json&query=' + encodeURIComponent(queryHeader),
			async: true,
			dataType: "json",

			success: function (data) {

				let frase = []
				for (let i = 9; i >= 0; i--) {
					if (data.results.bindings[0]["prev_t" + i + "_label"] !== undefined) {
						let tokenLabel = data.results.bindings[0]["prev_t" + i + "_label"].value;
						let token = data.results.bindings[0]["prev_t" + i + ""].value
						frase.push(<a className={"lilaToken"} href={token}> {tokenLabel}  </a>);
					}
				}
				if (frase.length === 10) {
					frase.unshift("...");
				}
				let tokenLabel = data.results.bindings[0]["tokenLabel"].value;
				let token = data.results.bindings[0]["token"].value
				frase.push(<a className={"lilaTokenRef"} href={token}> {tokenLabel}  </a>);
				for (let i = 0; i < 10; i++) {
					if (data.results.bindings[0]["next_t" + i + "_label"] !== undefined) {
						let tokenLabel = data.results.bindings[0]["next_t" + i + "_label"].value;
						let token = data.results.bindings[0]["next_t" + i + ""].value
						frase.push(<a className={"lilaToken"} href={token}> {tokenLabel}  </a>);
						if (i === 9) {
							frase.push("...");
						}
					}


				}


				resolve(frase)

			},
			error: function (err) {
				reject(err) // Reject the promise and go to catch()
			}

		});

	})

}


function execQuery(query) {
	return new Promise(function (resolve, reject) {
		$.ajax({
			//  url: 'https://lila-erc.eu/sparql/lemmaBank/query?format=csv&query=' + encodeURIComponent(query),
			// eslint-disable-next-line no-template-curly-in-string
			url: 'https://lila-erc.eu/sparql/lila_knowledge_base/query?format=json&query=' + encodeURIComponent(query),
			async: true,
			dataType: "json",

			success: function (data) {
				resolve(data);
			},
			error: function (err) {
				reject(err) // Reject the promise and go to catch()
			}

		});
	})
}

function execQuerySync(query) {
	let out
	$.ajax({
		//  url: 'https://lila-erc.eu/sparql/lemmaBank/query?format=csv&query=' + encodeURIComponent(query),
		// eslint-disable-next-line no-template-curly-in-string
		url: 'https://lila-erc.eu/sparql/lila_knowledge_base/query?format=json&query=' + encodeURIComponent(query),
		async: false,
		dataType: "json",

		success: function (data) {
			out = data;
		}

	});
	return out;
}

function renderTokenReference(tokenIRI) {
	let referenceItems = []

	return new Promise(function (resolve, reject) {
		let docQuery = "PREFIX rdfs: <http://www.w3.org/2000/01/rdf-schema#>\n" +
			"PREFIX lilaCorpora: <http://lila-erc.eu/ontologies/lila_corpora/>\n" +
			"PREFIX rdf: <http://www.w3.org/1999/02/22-rdf-syntax-ns#>\n" +
			"PREFIX dc: <http://purl.org/dc/elements/1.1/>\n" +
			"PREFIX powla: <http://purl.org/powla/powla.owl#>\n" +
			"SELECT ?doc ?docTitle ?citLayer ?citLayerLabel ?citUnit ?citUnitLabel WHERE {\n" +
			"  <" + tokenIRI + "> powla:hasLayer ?docLayer .\n" +
			"  ?docLayer powla:hasDocument ?doc.\n" +
			"  ?doc dc:title ?docTitle.\n" +
			"  ?citLayer rdf:type lilaCorpora:CitationStructure;\n" +
			"            powla:hasDocument ?doc;\n" +
			"            dc:title ?citLayerLabel;\n" +
			"            lilaCorpora:isLayer ?citUnit.\n" +
			"  ?citUnit rdfs:label ?citUnitLabel.\n" +
			"}"

		let citationTokenLevelQuery = "PREFIX rdfs: <http://www.w3.org/2000/01/rdf-schema#>\n" +
			"PREFIX powla: <http://purl.org/powla/powla.owl#>\n" +
			"SELECT ?cu ?cuLabel WHERE {\n" +
			"  ?cu powla:hasChild <" + tokenIRI + ">;\n" +
			"      rdfs:label ?cuLabel.\n" +
			"}";


		let docResult = execQuery(docQuery);

		docResult.then(function (result) {
			// console.log(result.results.bindings[0]);


			let docUri = result.results.bindings[0]["doc"].value
			let docTitle = result.results.bindings[0]["docTitle"].value
			let citLayer = result.results.bindings[0]["citLayer"].value
			let citationTokenLevel = execQuery(citationTokenLevelQuery)
			citationTokenLevel.then(function (result) {
				result.results.bindings.forEach(function (binding) {

					let cu = binding["cu"].value;
					let cuLabel = binding["cuLabel"].value;

					referenceItems.push(<a className={"lilaToken"} href={cu}>{cuLabel}</a>);
					let endOfCitation = false;
					let maxIteration = 10;
					let iteration = 0;
					while (!endOfCitation) {
						let layer = ""
						let currentCu = "PREFIX lilaCorpora: <http://lila-erc.eu/ontologies/lila_corpora/>\n" +
							"PREFIX rdfs: <http://www.w3.org/2000/01/rdf-schema#>\n" +
							"PREFIX powla: <http://purl.org/powla/powla.owl#>\n" +
							"SELECT ?cu ?cuLabel ?layer WHERE {\n" +
							"  optional{\n" +
							"  ?cu lilaCorpora:hasCitSubUnit <" + cu + ">;\n" +
							"      rdfs:label ?cuLabel.\n" +
							"  }\n" +
							"  optional{\n" +
							"    ?layer lilaCorpora:isLayer <" + cu + ">.\n" +
							"  }\n" +
							"}";

						let currentCuResuts = execQuerySync(currentCu);

						if (currentCuResuts.results.bindings[0]["cu"] !== undefined) {
							cu = currentCuResuts.results.bindings[0]["cu"].value
							cuLabel = currentCuResuts.results.bindings[0]["cuLabel"].value

							referenceItems.push(<a className={"lilaToken"} href={cu}>{cuLabel}</a>);
						}


						if (currentCuResuts.results.bindings[0]["layer"] !== undefined) {
							layer = currentCuResuts.results.bindings[0]["layer"].value;

						}

						if (layer === citLayer) {
							console.log("endOfCitation");
							break
						}
						if (iteration === maxIteration) {
							console.log("maxIteration");
							break
						}
						iteration++
					}
					referenceItems.push(<a className={"lilaToken"} href={docUri}>{docTitle}</a>)
					referenceItems = referenceItems.reverse()

					//referenceItems.unshift(<a className={"lilaToken"} href={docUri}>{docTitle}</a>)
					resolve(referenceItems)

				})

			})

		})
	})
}


function renderResourceMainCaption(uri) {
	return new Promise(function (resolve, reject) {
		// eslint-disable-next-line no-template-curly-in-string
		let queryDecr = resourceDescriptionPropertiesQuery.replaceAll("${IRI}", uri).replaceAll("<${FILTERS}>", buildFilterString(titleProperties))
		// console.log(queryDecr);
		$.ajax({
			// eslint-disable-next-line no-template-curly-in-string
			url: 'https://lila-erc.eu/sparql/lila_knowledge_base/query?format=json&query=' + encodeURIComponent(queryDecr),
			async: true,
			dataType: "json",

			success: function (data) {

				let output = [];
				if (data.results.bindings.length > 0) {
					output.push(
						<label className="c1">
							<span className="iph"></span>
							<a data-label="Description" data-comment="An account of the resource."
							   href={data.results.bindings[0].filterProperty.value}>
								{renderWithNamespace(data.results.bindings[0].filterProperty.value)}
							</a>
						</label>)

					output.push(data.results.bindings[0].o.value)

				}
				resolve(output);
			}
		})
	})


}


function renderResourceType(uri) {
	return new Promise(function (resolve, reject) {
		// eslint-disable-next-line no-template-curly-in-string
		let queryDecr = resourceDescriptionPropertiesQuery.replaceAll("${IRI}", uri).replaceAll("<${FILTERS}>", buildFilterString(types))
		// console.log(queryDecr);
		$.ajax({
			// eslint-disable-next-line no-template-curly-in-string
			url: 'https://lila-erc.eu/sparql/lila_knowledge_base/query?format=json&query=' + encodeURIComponent(queryDecr),
			async: true,
			dataType: "json",

			success: function (data) {
				// console.log(data.results.bindings)
				let output = [];
				if (data.results.bindings.length > 0) {
					// output.push()
					data.results.bindings.forEach((binding) => {
						output.push(<a key={uuidv4()} href={binding.o.value}
						               rdfType={binding.o.value}>{renderWithNamespace(binding.o.value)}</a>)
					})
					// output.push(data.results.bindings[0].o.value)

				}
				resolve(output);
			},
			error: function (err) {
				reject(err)
			}
		})
	})


}

export {
	executeSparql,
	renderWithNamespace,
	renderResourceTitle,
	renderResourceDescription,
	inverseQuery,
	renderResourceMainCaption,
	renderResourceType,
	renderTokenContext,
	renderTokenReference
};
